import React from 'react';
import { Visualization } from '../types/api';

interface VisualizationOptionsModalProps {
  viz: Visualization;
  newName: string;
  setNewName: (name: string) => void;
  onRename: () => void;
  onDelete: () => void;
  onClose: () => void;
}

export default function VisualizationOptionsModal({
  viz,
  newName,
  setNewName,
  onRename,
  onDelete,
  onClose
}: VisualizationOptionsModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="text-black bg-uiBackground rounded-lg p-8 min-w-[300px] shadow-lg">
        <h2 className="text-2xl font-bold">Visualization Options</h2>
        <div className="flex text-md font-medium items-center justify-between ml-4 mt-4">
          <label htmlFor="vizName">Visualization Name</label>
          <input
            id="vizName"
            type="text"
            className="w-full p-3 rounded-md border border-black mt-4 mb-4 bg-white focus:outline-none focus:ring-2 focus:ring-primary-light dark:focus:ring-primary-dark cursor-pointer"
            value={newName}
            onChange={e => setNewName(e.target.value)}
          />
        </div>
        <div className="flex justify-center gap-10">
          <button
            className="bg-red-500 text-white rounded-md px-4 py-2 hover:bg-red-600 transition-all duration-200"
            onClick={onDelete}
          >
            Delete
          </button>
          <button
            className="bg-primary-light text-white rounded-md px-4 py-2 hover:bg-secondary-dark transition-all duration-200"
            onClick={onRename}
          >
            Rename
          </button>
          <button
            className="bg-gray-300 dark:bg-gray-700 rounded-md px-4 py-2 hover:bg-gray-400 dark:hover:bg-gray-600 transition-all duration-200"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
